/* eslint-disable camelcase */
import joi from 'joi';

import { validateAndGenerateErrors } from '../../../../core/utils/validation';
import { STORE_FIELDS } from './storeFormFields';

const store_data_validation = joi.object({
  [STORE_FIELDS.CNPJ]: joi.string().required(),
  [STORE_FIELDS.NAME]: joi.string().required(),
  [STORE_FIELDS.WEBSITE_URL]: joi.string(),
  [STORE_FIELDS.MONTHLY_ORDERS]: joi.number().required(),
  [STORE_FIELDS.TIME_ZONE]: joi.string().required(),
  [STORE_FIELDS.EMAIL]: joi
    .string()
    .email({ tlds: { allow: false } })
    .required(),
  [STORE_FIELDS.TELEPHONE]: joi.string().min(11).required(),
  // [STORE_FIELDS.IMAGE_URL]: joi.string(),
  [STORE_FIELDS.STREET]: joi.string().required(),
  [STORE_FIELDS.CITY]: joi.string().required(),
  [STORE_FIELDS.STATE]: joi.string().required(),
  [STORE_FIELDS.ZIP_CODE]: joi.string().required(),
});

export const validateStoreData = (formData) => {
  return validateAndGenerateErrors(formData, store_data_validation);
};
